"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ShareWithIdentitiesTab = exports.SECOND_TAB = exports.PublicPortalTab = exports.FIRST_TAB = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Modal = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Modal"));
var _ModalHeader = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalHeader"));
var _Tabs = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Tabs"));
var _Tab = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Tab"));
var _TabList = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/TabList"));
var _TabPanel = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/TabPanel"));
var _ShareWithIdentitiesPanel = _interopRequireDefault(require("./ShareWithIdentitiesPanel"));
var _ShareToPublicPortalPanel = _interopRequireDefault(require("./ShareToPublicPortalPanel"));
var _utils = require("./utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = {
  "shared-modal": "ShareModal__shared-modal__2GeYs",
  "sharedModal": "ShareModal__shared-modal__2GeYs",
  "header": "ShareModal__header__3hjEa",
  "body": "ShareModal__body__2R_mn",
  "footer": "ShareModal__footer__32UEO",
  "title": "ShareModal__title__3rsku",
  "modal-header": "ShareModal__modal-header__2vvfm",
  "modalHeader": "ShareModal__modal-header__2vvfm",
  "tabs-container": "ShareModal__tabs-container__5BUM5",
  "tabsContainer": "ShareModal__tabs-container__5BUM5",
  "without-tabs": "ShareModal__without-tabs__1k-DM",
  "withoutTabs": "ShareModal__without-tabs__1k-DM",
  "tab-label": "ShareModal__tab-label__23nML",
  "tabLabel": "ShareModal__tab-label__23nML",
  "tab-label-description": "ShareModal__tab-label-description__1yCxQ",
  "tabLabelDescription": "ShareModal__tab-label-description__1yCxQ"
}; 
require('./ShareModal.css');
var FIRST_TAB = exports.FIRST_TAB = 0;
var SECOND_TAB = exports.SECOND_TAB = 1;
var PublicPortalTab = exports.PublicPortalTab = function PublicPortalTab() {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, "Public"), /*#__PURE__*/_react.default.createElement("div", {
    className: styles.tabLabelDescription
  }, "Publish it on the public portal"));
};
var ShareWithIdentitiesTab = exports.ShareWithIdentitiesTab = function ShareWithIdentitiesTab() {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, "Collaborators"), /*#__PURE__*/_react.default.createElement("div", {
    className: styles.tabLabelDescription
  }, "Grant roles to users and teams"));
};
var ShareModal = /*#__PURE__*/function (_React$Component) {
  function ShareModal() {
    var _this;
    (0, _classCallCheck2.default)(this, ShareModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ShareModal, [].concat(args));
    (0, _defineProperty2.default)(_this, "state", {
      isShareWithIdentitiesDirty: false,
      isShareToPublicPortalDirty: false,
      resetShareWithIdentities: false,
      resetShareToPublicPortal: false,
      selectedTabIndex: FIRST_TAB
    });
    (0, _defineProperty2.default)(_this, "handleTabChange", function (_ref) {
      var prevTabSelected = _ref.prevValue;
      var _this$state = _this.state,
        isShareWithIdentitiesDirty = _this$state.isShareWithIdentitiesDirty,
        isShareToPublicPortalDirty = _this$state.isShareToPublicPortalDirty;
      var showConfirm = function showConfirm() {
        return global.confirm('Are you sure you want to switch tabs? All unsaved changes will be lost');
      };
      return (0, _defineProperty2.default)((0, _defineProperty2.default)({}, FIRST_TAB, function () {
        if (isShareWithIdentitiesDirty) {
          if (!showConfirm()) {
            return false;
          }
          _this.setState(function (prevState) {
            return _objectSpread(_objectSpread({}, prevState), {}, {
              resetShareWithIdentities: !prevState.resetShareWithIdentities
            });
          });
        }
        return true;
      }), SECOND_TAB, function () {
        if (isShareToPublicPortalDirty) {
          if (!showConfirm()) {
            return false;
          }
          _this.setState(function (prevState) {
            return _objectSpread(_objectSpread({}, prevState), {}, {
              resetShareToPublicPortal: !prevState.resetShareToPublicPortal
            });
          });
        }
        return true;
      })[prevTabSelected]();
    });
    (0, _defineProperty2.default)(_this, "setIsShareWithIdentitiesDirty", function (isDirty) {
      _this.setState({
        isShareWithIdentitiesDirty: isDirty
      });
    });
    (0, _defineProperty2.default)(_this, "setIsShareToPublicPortalDirty", function (isDirty) {
      _this.setState({
        isShareToPublicPortalDirty: isDirty
      });
    });
    return _this;
  }
  (0, _inherits2.default)(ShareModal, _React$Component);
  return (0, _createClass2.default)(ShareModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        asset = _this$props.asset,
        closeModal = _this$props.closeModal,
        profile = _this$props.profile,
        visibility = _this$props.visibility,
        customCallouts = _this$props.customCallouts;
      var _this$state2 = this.state,
        selectedTabIndex = _this$state2.selectedTabIndex,
        resetShareWithIdentities = _this$state2.resetShareWithIdentities,
        resetShareToPublicPortal = _this$state2.resetShareToPublicPortal;
      var _ShareToPublicPortalC = _objectSpread({
          ShareToPublicPortalCallout: function ShareToPublicPortalCallout() {
            return null;
          },
          ShareWithIdentitiesCallout: function ShareWithIdentitiesCallout() {
            return null;
          },
          ShareToPublicPortalInformation: function ShareToPublicPortalInformation() {
            return null;
          }
        }, customCallouts),
        ShareWithIdentitiesCallout = _ShareToPublicPortalC.ShareWithIdentitiesCallout,
        ShareToPublicPortalCallout = _ShareToPublicPortalC.ShareToPublicPortalCallout,
        ShareToPublicPortalInformation = _ShareToPublicPortalC.ShareToPublicPortalInformation;
      var canSharePublicly = (0, _utils.isExchangeAdminOfOrganization)(profile, asset.organization);
      var canMakeItPublic = canSharePublicly && visibility === 'public';
      var labelId = 'share-modal-title';
      return /*#__PURE__*/_react.default.createElement(_Modal.default, {
        renderInBody: false,
        className: styles.sharedModal,
        testId: "share-asset-modal",
        onClickOverlay: closeModal,
        onEsc: closeModal,
        ariaLabelledBy: labelId
      }, /*#__PURE__*/_react.default.createElement(_ModalHeader.default, {
        testId: "modal-header"
      }, /*#__PURE__*/_react.default.createElement("h2", {
        id: labelId,
        className: styles.modalHeader
      }, "Share")), /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(styles.tabsContainer, (0, _defineProperty2.default)({}, styles.withoutTabs, !canMakeItPublic))
      }, canMakeItPublic ? /*#__PURE__*/_react.default.createElement(_Tabs.default, {
        selectWithArrows: true,
        selectedIndex: selectedTabIndex,
        onBeforeChange: this.handleTabChange,
        onChange: function onChange(_ref2) {
          var value = _ref2.value;
          _this2.setState({
            selectedTabIndex: value
          });
        }
      }, /*#__PURE__*/_react.default.createElement(_TabList.default, null, /*#__PURE__*/_react.default.createElement(_Tab.default, {
        className: styles.tabLabel,
        "data-test-id": "tab-share-with-identities"
      }, /*#__PURE__*/_react.default.createElement(ShareWithIdentitiesTab, null)), /*#__PURE__*/_react.default.createElement(_Tab.default, {
        className: styles.tabLabel,
        "data-test-id": "tab-public-portal",
        disabled: !canMakeItPublic
      }, /*#__PURE__*/_react.default.createElement(PublicPortalTab, null))), /*#__PURE__*/_react.default.createElement(_TabPanel.default, null, /*#__PURE__*/_react.default.createElement(_ShareWithIdentitiesPanel.default, {
        asset: asset,
        onClose: closeModal,
        onUpdate: this.setIsShareWithIdentitiesDirty,
        reset: resetShareWithIdentities,
        CustomCallout: ShareWithIdentitiesCallout
      })), /*#__PURE__*/_react.default.createElement(_TabPanel.default, null, /*#__PURE__*/_react.default.createElement(_ShareToPublicPortalPanel.default, {
        asset: asset,
        onClose: closeModal,
        onUpdate: this.setIsShareToPublicPortalDirty,
        reset: resetShareToPublicPortal,
        InformationCallout: ShareToPublicPortalInformation,
        CustomCallout: ShareToPublicPortalCallout
      }))) : /*#__PURE__*/_react.default.createElement(_ShareWithIdentitiesPanel.default, {
        asset: asset,
        onClose: closeModal,
        onUpdate: this.setIsShareWithIdentitiesDirty,
        reset: resetShareWithIdentities,
        CustomCallout: ShareWithIdentitiesCallout
      })));
    }
  }]);
}(_react.default.Component);
(0, _defineProperty2.default)(ShareModal, "defaultProps", {
  profile: null,
  customCallouts: {}
});
var _default = exports.default = ShareModal;
//# sourceMappingURL=ShareModal.js.map